var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOutgoingCallAnswered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    name: "icon-outgoing-call",
    width: 17,
    height: 17,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.99443 0L0.52287 0.221675C0.227419 0.221675 0.00582994 0.517241 0.00582994 0.738916C-0.068033 4.50739 0.522871 7.83251 3.92056 11.2315C7.31826 14.6305 10.4944 15 14.2614 15C14.5568 15 14.7784 14.7783 14.7784 14.4828L15 11.0099C15 10.7143 14.7784 10.4926 14.5568 10.4187L11.0853 9.90148C10.9375 9.90148 10.716 9.90148 10.6421 10.0493C9.8296 10.8621 9.23869 11.4532 9.0171 11.601C8.64779 11.4532 7.31826 10.8621 5.841 9.31034C4.36374 7.83251 3.62511 6.35468 3.40352 5.98522C3.69898 5.68965 4.36374 5.02463 4.95464 4.4335C5.10237 4.28571 5.10237 4.13793 5.10237 3.99015L4.58533 0.44335C4.58533 0.221675 4.28988 0 3.99443 0Z",
    fill: "#D2D2D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91748 1.52209H11.2739V-7.10487e-05L14.6495 3.04426L11.2739 6.07129V4.54912H7.91748L7.91748 1.52209Z",
    fill: "#06bf09"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOutgoingCallAnswered);
export default __webpack_public_path__ + "static/media/icon-outgoing-call-answered.f6d6e248c24e5a7562f88760211f957a.svg";
export { ForwardRef as ReactComponent };